var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dimensionTable"},[_c('QS-h4-title',{attrs:{"title":"运营情况-企业","content":_vm.dateText}}),_vm._v(" "),_c('QS-common-table',{attrs:{"max-height":400,"data":_vm.tableData,"columns":_vm.columns,"pagination":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }